import { render, staticRenderFns } from "./BlockRegisterInfo.vue?vue&type=template&id=9568c96a&"
import script from "./BlockRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./BlockRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports